import { createStyles, Theme, WithStyles, withStyles } from "@material-ui/core/styles";
import { Variant } from "@material-ui/core/styles/createTypography";
import Typography from "@material-ui/core/Typography";
import classNames from "classnames";
import React from "react";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(1),
      color: theme.palette.text.primary,
    },
    rootLabel: {
      color: theme.palette.text.secondary,
      fontSize: "75%",
    },
    rootNoMargin: {
      margin: 0,
    },
  });

interface TitleProps extends WithStyles<typeof styles> {
  fieldId: string;
  title: string;
  margin?: "normal" | "none";
  variant?: Variant | "label";
  allowHtml?: boolean;
}

export const TitleComponent = (props: TitleProps) => {
  const { margin = "normal", variant = "h5", allowHtml, classes } = props;

  const muiVariant = variant !== "label" ? variant : undefined;

  const title = allowHtml ? <span dangerouslySetInnerHTML={{ __html: props.title }} /> : props.title;

  return title ? (
    <Typography
      className={classNames(
        classes.root,
        variant === "label" && classes.rootLabel,
        margin === "none" && classes.rootNoMargin,
      )}
      variant={muiVariant}
    >
      {title}
    </Typography>
  ) : null;
};

export const Title = withStyles(styles)(TitleComponent);
